import { PostHogProvider } from 'posthog-js/react';
import type { FunctionComponent, ReactNode } from 'react';

import { ApiProvider } from '#modules/api/providers/api.provider';
import { ReservationProvider } from '#modules/reservation/store';

export interface ProvidersProps {
  readonly children?: ReactNode;
}

export const Providers: FunctionComponent<ProvidersProps> = (props) => {
  const { children } = props;

  const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
  const debug = import.meta.env.MODE === 'development';

  const content = (
    <ApiProvider>
      <ReservationProvider>{children}</ReservationProvider>
    </ApiProvider>
  );

  if (!posthogKey) {
    return content;
  }

  return (
    <PostHogProvider
      apiKey={posthogKey}
      options={{
        api_host: posthogHost,
        defaults: '2025-11-30',
        debug,
      }}
    >
      {content}
    </PostHogProvider>
  );
};
